import { ProjectMetadata } from 'const/ProjectMetadata';
import { intlGet } from 'utils/intlGet';

export enum ProjectMetadataTypeMedComms {
  JOB_ID = 'DocNumb',
  PROJECTED_APPROVAL_DATE = 'ProjApproval',
  ASSET_ID = 'AssetNumber',
}

export const ProjectMetadataMapMedcomms: Record<ProjectMetadataTypeMedComms, ProjectMetadata> = {
  [ProjectMetadataTypeMedComms.JOB_ID]: {
    key: 'number',
    title: intlGet('EditorToolbar.Token.Property.JobId', 'Title'),
    description: intlGet('EditorToolbar.Token.Property.JobId', 'Description'),
  },
  [ProjectMetadataTypeMedComms.PROJECTED_APPROVAL_DATE]: {
    key: 'projectedApprovalDate',
    title: intlGet('EditorToolbar.Token.Property.ProjectedApprovalDate', 'Title'),
    description: intlGet('EditorToolbar.Token.Property.ProjectedApprovalDate', 'Description'),
  },
  [ProjectMetadataTypeMedComms.ASSET_ID]: {
    key: 'assetNumber',
    title: intlGet('EditorToolbar.Token.Property.AssetId', 'Title'),
    description: intlGet('EditorToolbar.Token.Property.AssetId', 'Description'),
  },
};
